var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{staticClass:"timer",attrs:{"fill":_vm.fill,"fill-opacity":_vm.fillOpacity,"d":_vm.path,"transform":("translate(" + (_vm.width / 2) + "," + (_vm.height / 2) + ")")}})])}
var staticRenderFns = []

export { render, staticRenderFns }